import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NetworkLogo } from "../icons";
import { AddressView } from "../parameters";
const PREFIX_TO_NETWORK = {
    eth: "Mainnet",
    oeth: "Optimism",
    arb1: "Arbitrum",
};
export const MultisigWatcherCard = ({ data }) => {
    return (_jsxs("div", { children: [_jsx("div", { className: "font-bold text-lg mt-4 mb-1", children: "Safe Addresses:" }), _jsx("div", { className: "flex flex-col", children: data.safeAddresses.map(s => (_jsx(SafeAddress, { value: s }, s))) })] }));
};
const SafeAddress = ({ value }) => {
    const idx = value.indexOf(":");
    const prefix = idx === -1 ? "" : value.slice(0, idx);
    const address = value.slice(idx + 1);
    const network = PREFIX_TO_NETWORK[prefix];
    return (_jsx("div", { className: "flex flex-row items-center gap-2", children: network ? (_jsxs(_Fragment, { children: [_jsx(NetworkLogo, { network: network, size: 16 }), _jsx(AddressView, { address: address, network: network, compact: true })] })) : (_jsxs(_Fragment, { children: [prefix && _jsx("span", { className: "font-mono", children: prefix }), _jsx(AddressView, { address: address, compact: true, hideEtherscan: true })] })) }));
};
